module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "boxContainer"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userTypeSelect"
  }, [_vm._v("医院版用户")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "btn_row"
  }, [_c('div', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.onBtnSelect('cgms')
      }
    }
  }, [_c('p', [_vm._v("医院版报表系统")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userTypeSelect"
  }, [_vm._v("门诊版用户")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "btn_row"
  }, [_c('div', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.onBtnSelect('report')
      }
    }
  }, [_c('p', [_vm._v("门诊版报表系统")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("| 隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("| 服务协议 | ")]), _vm._v("\n\n      ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("\n        沪ICP备08013753号-3\n      ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v("\n        沪公网安备 31011502014155号\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/report/logo_zyw.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("移宇在线报表系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userType"
  }, [_c('p', [_vm._v("请选择用户类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("我使用移宇医院版App管理患者")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("我使用移宇门诊版App管理患者")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-391a59e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserTypeSelect.vue
// module id = 718
// module chunks = 1